import { MachineContext } from 'contexts/machine.context';
import { SectionName } from 'enums/route.enums';
import { useActiveRoute } from 'hooks/useActiveRoute';
import usePrevious from 'hooks/usePrevious';
import { SpecialMsPosition } from 'lib_ts/interfaces/machine-msg/i-special-mstarget';
import { useContext, useEffect } from 'react';

/** Lower MS when navigating away from pitches */
export const useAutoResetMs = () => {
  const { machine, specialMsTarget } = useContext(MachineContext);
  const { section: activeSection } = useActiveRoute();
  const prevSection = usePrevious<SectionName | undefined>(activeSection);

  useEffect(() => {
    if (!machine.enable_auto_reset_ms) {
      return;
    }

    if (activeSection === SectionName.Pitches) {
      return;
    }

    if (prevSection !== SectionName.Pitches) {
      return;
    }

    // user has left pitches section
    specialMsTarget(SpecialMsPosition.lowered);
  }, [
    activeSection,
    machine.enable_auto_reset_ms,
    prevSection,
    specialMsTarget,
  ]);
};
